import React from 'react'
import { Link } from 'react-router-dom'

import img1 from '../../../assets/img/properties/1.jpg';
import img2 from '../../../assets/img/properties/2.jpg';
import img3 from '../../../assets/img/properties/3.jpg';
import img4 from '../../../assets/img/properties/4.jpg';
import img5 from '../../../assets/img/properties/5.jpg';

const teamblock = [
    { img: img1, name: 'Encanto', description: 'Encanto is a condominium complex located in the prestigious Aldea Zama; a master planned community that offers the best services, amenities and real estate in Tulum.', link: 'https://www.airbnb.com/rooms/40854623', icon: "fab fa-airbnb" },
    { img: img2, name: 'The Highline, Aldea Zama', description: 'The Highline, Aldea Zama is the perfect setting to usher you to your dream vacation, adventure holiday, couple getaway or just time away to unwind or re-invent yourself…', link: 'https://www.airbnb.com/rooms/40793066', icon: "fab fa-airbnb" },
    { img: img3, name: 'Mountainside Casa In Pagosa Springs', description: 'Gorgeous Mountain Views. Pagosa Hot Springs 10 min away. Only 25 miles to Wolf Creek Ski Area (Most snow for Skiing in USA). Just 5 min to Uptown – 10 mins to downtown.', link: 'https://www.airbnb.com/rooms/44847719', icon: "fab fa-airbnb" },
    { img: img4, name: 'Luxurious Penthouse w/ Rooftop Terrace', description: 'A peaceful and tranquil getaway, our 2 bedroom contemporary penthouse is nestled amidst the grandeur of the Riviera Maya. Take in the beautiful Caribbean sunset on a private scenic terrace', link: 'https://www.vrbo.com/2174061?unitId=2738597', icon: "fab fa-think-peaks" },
    { img: img5, name: 'Lush Garden Oasis Quintana Roo', description: 'Lush garden 2 bedroom ground floor apartment with a stylish kitchen and lounge. Enjoy the scenic views of the Tao Tulum community and Caribbean sunsets on a private garden patio.', link: 'https://www.airbnb.com/rooms/48205951', icon: "fab fa-airbnb" },
]
function Propertiesblock(props) {
    return (
        <section className="team-section section-gap">
            <div className="container">
                {/* Section Title */}
                <div className="section-title mb-40 both-border text-center">
                    <span className="title-tag">Luxury Properties</span>
                    {/* <h2 className="title">We Have An Exclusive <br /> Team Member</h2> */}
                </div>
                {/* Team Boxes */}
                <div className="row team-members justify-content-center">
                    {teamblock.map((item, i) => (
                        <div key={i} className="col-lg-6 col-md-6 col-6 col-tiny-12">
                            <div className="team-member">
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    <div className="member-picture-wrap">
                                        <div className="member-picture">
                                            <img src={item.img} alt="" />
                                            <div className="social-icons">
                                                <Link to="/">
                                                    <i className={item.icon} />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                <div className="member-desc">
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" className='name'>
                                        <h3 className="name">{item.name}</h3>
                                    </a>
                                    <span className="pro">{item.description}</span>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Propertiesblock;